import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './SplashScreen.css';
import logoImg from '../assets/logo.png';

const SplashScreen = ({ onFinish }) => {
    const [step, setStep] = useState(0);

    useEffect(() => {
        // Step 1: Show logo and text (Done by framer motion initial)
        
        // Step 2: Start the ripple "cleaning" effect
        const timer1 = setTimeout(() => setStep(1), 1500);
        
        // Step 3: Finish and remove splash
        const timer2 = setTimeout(() => {
            if (onFinish) onFinish();
        }, 3000);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, [onFinish]);

    return (
        <motion.div 
            className="splash-overlay"
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
        >
            {/* Mist layer that gets "cleaned" */}
            <motion.div 
                className="mist-layer"
                initial={{ opacity: 1 }}
                animate={step >= 1 ? { 
                    opacity: 0,
                    scale: 2,
                    filter: "blur(0px)"
                } : {}}
                transition={{ duration: 1.5, ease: "easeOut" }}
            />

            <div className="splash-content">
                <motion.img 
                    src={logoImg} 
                    alt="RoulezPropre" 
                    className="splash-logo"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ 
                        duration: 1, 
                        ease: "easeOut",
                        type: "spring",
                        stiffness: 100
                    }}
                />
                
                <motion.div 
                    className="splash-text text-reveal"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                >
                    <span style={{ color: '#3b82f6' }}>Roulez</span> Propre
                </motion.div>
            </div>

            {/* Expansion circle effect */}
            <AnimatePresence>
                {step === 1 && (
                    <motion.div 
                        style={{
                            position: 'absolute',
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            background: 'white',
                            boxShadow: '0 0 100px 50px white',
                            zIndex: 4
                        }}
                        initial={{ scale: 0, opacity: 1 }}
                        animate={{ scale: 40, opacity: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 1.2, ease: "easeIn" }}
                    />
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export default SplashScreen;
